import { Pie } from '@ant-design/charts';
import { Empty, Select } from 'antd';
import { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import useDashboard from './hook/useDashboard';
import { useTranslation } from 'react-i18next';

export default function PieChart({ refresh, setRefresh }) {
    const { t } = useTranslation();
    const [data, setData] = useState([]);
    const [dataBreachFormGroupId, setDataBreachFormGroupId] = useState('');
    const { groupList, circleChart, getGroupList, getCircleChart } =
        useDashboard();

    useEffect(() => {
        getGroupList();
    }, [getGroupList]);

    useEffect(() => {
        if (refresh && dataBreachFormGroupId) {
            getCircleChart(dataBreachFormGroupId);
            setRefresh(false);
        }
    }, [dataBreachFormGroupId, getCircleChart, refresh, setRefresh]);

    // Set default group id
    useEffect(() => {
        if (groupList.length > 0) {
            setDataBreachFormGroupId(groupList[0].value);
            getCircleChart(groupList[0].value);
        }
    }, [groupList, getCircleChart]);

    const onChange = (value) => {
        setDataBreachFormGroupId(value);
        getCircleChart(value);
    };

    useEffect(() => {
        if (circleChart.length > 0) {
            const data = circleChart.map((item) => ({
                type: item.dataBreachName,
                value: item.dataBreachCount,
            }));
            setData(data);
        } else {
            setData([]);
        }
    }, [circleChart]);

    const config = useMemo(() => {
        return {
            data,
            angleField: 'value',
            colorField: 'type',
            radius: 0.8,
            label: {
                text: (d) => `${d.type}\n ${d.value}`,
                position: 'spider',
            },
            legend: {
                color: {
                    title: false,
                    position: 'right',
                    rowPadding: 5,
                },
            },
        };
    }, [data]);

    const isEmptyData = data.every((item) => item.value === 0);

    return (
        <div>
            <div className="flex justify-between items-center">
                <div className="text-lg font-semibold">
                    {t('Type of incident')}
                </div>
                <Select
                    className="w-96"
                    size="large"
                    value={dataBreachFormGroupId}
                    onChange={onChange}
                    options={groupList}
                />
            </div>
            {isEmptyData ? (
                <Empty
                    className="mt-20"
                    description={
                        <span className="text-base text-[#95A0A8]">
                            ไม่พบข้อมูล
                        </span>
                    }
                />
            ) : (
                <div className="p-4">
                    <Pie {...config} />
                </div>
            )}
        </div>
    );
}

// Validate props
PieChart.propTypes = {
    refresh: PropTypes.bool,
    setRefresh: PropTypes.func,
};
